module.exports = __webpack_public_path__ + "img/1.63b294b0.jpg";